<template>
<div class="body apply">
    <div class="wrap w-100per">
        <div class="apply-menu-wrap1" :style="[pageUrl === '/user/reg/select' ? {'display': 'none'} : {}]">
            <div class="top-menu">
                <h1>
                    <img v-if="logo !== '' || logo !== 'null' || logo !== 'undefined'" :src="logo" alt="company logo" class="h-30px">
                    <div v-else alt="company logo" style="height:40px"/>
                    <span v-if="mainTitle !== ''">{{mainTitle}}</span>
                    <span v-else>사내어학과정</span>
                </h1>
                <ul>
                    <li class="on-blue">
                        <a v-if="pageType === 'reg'">신청하기</a>
                        <a v-else class="pointer" >신청하기</a>
                    </li>
                    <li>
                        <a class="pointer">신청내역 확인</a>
                    </li>
                    <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
                    <li>
                        <a class="pointer">Logout</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="con">
            <div class="title">
                <h2>신청 안내</h2>
                <p>신청 전 아래의 정보를 확인 하신 후 신청해 주세요!</p>
            </div>
            <progress-bar></progress-bar>
            <div class="mt-50">
                <div class="apply-fieldset">
                    <!-- 다운로드 버튼이 상단 왼쪽일 경우 -->
                    <!-- <div class="down-btn-tl">
                            <button>3차수 안내 다운로드</button>
                        </div> -->

                    <!-- 다운로드 버튼이 상단 오른쪽일 경우 -->
                    <div class="down-btn-tr" v-if="buttonPosition === 'T'">
                        <button v-if="buttonName1 && buttonFileUrl1"   @click="downloadURI(1)">{{buttonName1}}</button>
                        <button v-if="buttonName2 && buttonFileUrl2" @click="downloadURI(2)" class="ml-10">{{buttonName2}}</button>
                    </div>

                    <div class="hq-table-row" v-html="guideContents">
                    </div>

                    <!-- 다운로드 버튼이 하단 왼쪽일 경우 -->
                    <div class="down-btn-bl" v-if="buttonPosition === 'B'">
                        <button v-if="buttonName1 && buttonFileUrl1" @click="downloadURI(1)">{{buttonName1}}</button>
                        <button v-if="buttonName2 && buttonFileUrl2" @click="downloadURI(2)" class="ml-10">{{buttonName2}}</button>
                    </div>

                    <!-- 다운로드 버튼이 하단 오른쪽일 경우 -->
                    <!-- <div class="down-btn-br">
                            <button>3차수 안내 다운로드</button>
                        </div> -->
                </div>
            </div>
            <div class="apply-agree-btn">
                <button type="button">수강신청 하기</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'

export default {
    data: () => ({
        buttonFileName1: '', // 1번째 버튼 파일 이름
        buttonFileName2: '', // 2번째 버튼 파일 이름
        buttonFileUrl1: '', // 1번째 버튼 파일 url
        buttonFileUrl2: '', // 2번재 버튼 파일 url
        buttonName1: '', // 1번째 버튼 이름
        buttonName2: '', // 2번째 버튼 이름
        buttonPosition: '', // 버튼 위치 포지션 T: Top, B: Bottom
        guideContents: '', // 가이드 내용 html

        logo: ''
    }),
    mounted() {
        var oParams = GetUrlParams()
        this.mainIdx = oParams.mainIdx

        var summaryIdx = this.mainIdx
        var params = {
            summaryIdx: summaryIdx
        }

        this.axios.get(this.axios.root + this.axios.port + `/sugang/guide/${summaryIdx}`, {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.logo = res.data.guideInfo.company_logo_file_url
                this.buttonFileName1 = res.data.guideInfo.button_file_name1, // 1번째 버튼 파일 이름
                    this.buttonFileName2 = res.data.guideInfo.button_file_name2, // 2번째 버튼 파일 이름
                    this.buttonFileUrl1 = res.data.guideInfo.button_file_url1, // 1번째 버튼 파일 url
                    this.buttonFileUrl2 = res.data.guideInfo.button_file_url2, // 2번재 버튼 파일 url
                    this.buttonName1 = res.data.guideInfo.button_name1, // 1번째 버튼 이름
                    this.buttonName2 = res.data.guideInfo.button_name2, // 2번째 버튼 이름
                    this.buttonPosition = res.data.guideInfo.button_position, // 버튼 위치 포지션 T: Top, B: Bottom
                    this.guideContents = res.data.guideInfo.guide_contents // 가이드 내용 html
            } else {
                alert(res.data.result)
            }
        })
    },

    methods: {}
}
</script>
